import { AudioLines, Film } from "lucide-react"
import { cn } from "@/lib/utils"
import { videoFirstFrameSrc } from "@/lib/video-timeline"

export type ReferenceMediaPreviewProps = {
  url: string
  mediaType?: "image" | "video" | "audio"
  thumbUrl?: string | null
  className?: string
  showVideoBadge?: boolean
}

export function ReferenceMediaPreview({
  url,
  mediaType = "image",
  thumbUrl,
  className,
  showVideoBadge = false,
}: ReferenceMediaPreviewProps) {
  if (mediaType === "audio") {
    return (
      <div
        className={cn("relative flex items-center justify-center dark:bg-ui-bg-elevated light:bg-clay-2", className)}
      >
        <AudioLines className="h-6 w-6 text-ui-text-secondary" aria-hidden />
        <audio src={url} preload="metadata" className="sr-only" />
      </div>
    )
  }

  if (mediaType === "video") {
    return (
      <div
        className={cn("relative flex items-center justify-center dark:bg-ui-bg-elevated light:bg-clay-2", className)}
      >
        <video
          src={videoFirstFrameSrc(url)}
          className="h-full w-full object-cover"
          muted
          preload="metadata"
          playsInline
        />
        {showVideoBadge ? <Film className="absolute right-0.5 bottom-0.5 h-3 w-3 text-ui-link drop-shadow" /> : null}
      </div>
    )
  }

  return <img src={thumbUrl ?? url} alt="" className={cn("object-cover", className)} draggable={false} />
}
